import { Directive } from '@angular/core';

@Directive({
  selector: '[appNgUnless]'
})
export class NgUnlessDirective {

  constructor() { }

}
